import { put } from "redux-saga/effects";

import * as segmentActions from "actions/segments";
import { addTimingMeasureInstructionsToAction } from "utils/timing";
import * as actionTypes from "constants/actionTypes";

export function* replaceAccountSegment(res) {
  const { key, data } = res;

  const replacementSegment = data
    ? { ...data, description: data.description || "" }
    : data;

  yield put(segmentActions.replaceAccountSegment(key, replacementSegment));
}

export function* replaceAccountSegments(res) {
  const { data } = res;

  const segmentData = Object.keys(data || {}).reduce((acc, segmentId) => {
    const segment = data[segmentId] || {};
    return {
      ...acc,
      [segmentId]: {
        ...segment,
        description: segment.description || ""
      }
    };
  }, {});

  yield put(
    addTimingMeasureInstructionsToAction(
      segmentActions.replaceAccountSegments(segmentData),
      actionTypes.SYNC_ACCOUNT_WITH_FIREBASE
    )
  );
}
